/**
 * @file Stats.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Stats component.
 */
const vStats = () => {
	const stats = document.querySelector('.v-stats');

	if (!stats) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const numbers = stats.querySelectorAll('.v-stats__number');
	numbers.forEach((number) => {
		const numberInt = number.querySelector('.v-stats__number-int');
		const numberIntValue = parseFloat(numberInt.innerText.replace(/,/g, ''));
		const startingNumber = Math.floor(numberIntValue * 0.7);

		gsap.fromTo(numberInt, { textContent: startingNumber }, {
			textContent: numberIntValue,
			duration:    1,
			ease:        'sine.out',
			snap:        { textContent: 1 },
			onUpdate() {
				numberInt.innerText = Intl.NumberFormat('en-us').format(this.targets()[0].textContent);
			},
			scrollTrigger: {
				trigger:       number,
				start:         'center bottom',
				end:           '+=1px',
				toggleActions: 'play none none none',
			},
		});
	});
};

export default vStats;
